export const MAX_FILE_DIMENSIONS = 1024 * 1024 * 10;
export const SUPPORTED_FORMATS = [
  'image/jpg',
  'image/jpeg',
  'image/png',
];

export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';
  const c = 1024;
  const e = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const f = Math.floor(Math.log(bytes) / Math.log(c));
  return parseFloat((bytes / Math.pow(c, f)).toFixed(decimals)) + ' ' + e[f];
};


export default {
  MAX_FILE_DIMENSIONS,
  SUPPORTED_FORMATS,
  formatBytes,
};
